import React, { Component } from 'react';
//import logo from './logo.svg';
//import ear from './ear_512x512.png';
import couchcast_logo from './couchcast_logo.png';

import './SignInPage.css';
import Broadcast from './Broadcast';

import { Link } from "react-router-dom";

class SignInPage extends Component {
  render() {

    
    function focusedInput(e){
      
      if((e.target.value === "enter email")||(e.target.value === "password")){
        e.target.value = "";
      }
    }

    function handleClick(e) {
      e.preventDefault();
      console.log('The link was clicked.');
    }

    function broadcastInputSignInPageClickHandler(e){
      e.preventDefault();
      console.log('The broadcastInputSignInPageClickHandler was clicked.');
      return(<Broadcast />);
    }
    function listenInputSignInPageClickHandler(e){
      e.preventDefault();
      console.log('The listenInputSignInPageClickHandler was clicked.');
    }
    
    function searchBoxChanged(e){
      //e.preventDefault();
      var newvalue = e.target.value.toString();
      console.log('The search now says: ',newvalue);
      //document.getElementById("inputBroadcastSearchBox").value = newvalue;
    }

    /*

            <Link to={`/Broadcast/`} className="btn-footer-SignInPage">Broadcast</Link>
            <Link to={`/Listen/`} className="btn-footer-SignInPage">Listen</Link>

            <button className="btn-footer" id="startSignInPageInput" onClick={handleClick}>Sign In</button>
              
    */


    return (
      <div className="SignInPage">
        <header className="SignInPage-header">
            
          <input id="inputSignInPageUsername" type="email"  onFocus={focusedInput} onChange={searchBoxChanged} className="SignInPage-inputBox" defaultValue="enter email"></input>
          <input id="inputSignInPagePassword" type="password" onFocus={focusedInput} onChange={searchBoxChanged} className="SignInPage-inputBox" defaultValue="password"></input>
          
        </header>
        <article>
          
        <img src={couchcast_logo} className="SignInPage-couchcast_logo" alt="couchcast_logo" />
       

        </article>
        <p className="SignInPage-intro">
          
        </p>
        <footer className="footer-SignInPage">
          <div className="SignInPage-footer-SignInPage">
            <Link to={`/Home/`} className="btn-footer-home">Sign In</Link>

          </div>
        </footer>
      </div>
    );
  }
}

export default SignInPage;



// WEBPACK FOOTER //
// ./src/components/SignInPage.js